<template>
	<v-dialog v-model="showWelcome" max-width="480" persistent>
		<v-card rounded="lg" elevation="2">
			<v-card-title class="bg-primary text-white d-flex align-center ga-2 py-4">
				<v-icon size="28">mdi-hand-wave</v-icon>
				{{ $t("tours.welcome.title") }}
			</v-card-title>

			<v-card-text class="pt-5 pb-2">
				<p class="text-body-1 mb-4">
					{{ $t("tours.welcome.description") }}
				</p>

				<v-chip
					color="warning"
					variant="tonal"
					size="small"
					prepend-icon="mdi-star"
				>
					{{ $t("tours.welcome.recommended") }}
				</v-chip>
			</v-card-text>

			<v-card-actions class="pa-4">
				<v-btn variant="text" @click="onSkip">
					{{ $t("tours.welcome.skip") }}
				</v-btn>
				<v-spacer />
				<v-btn
					color="primary"
					variant="flat"
					prepend-icon="mdi-play-circle-outline"
					@click="onStart"
				>
					{{ $t("tours.welcome.start") }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useTour } from "@/composables/useTour";

const route = useRoute();
const authStore = useAuthStore();
const { isFirstVisit, startGuidedTour, markGuidedTourCompleted } = useTour();

const showWelcome = ref(false);

watch(
	() => [route.name, authStore.user],
	() => {
		if (
			route.name === "Dashboard" &&
			authStore.user &&
			isFirstVisit.value
		) {
			showWelcome.value = true;
		}
	},
	{ immediate: true },
);

function onStart() {
	showWelcome.value = false;
	startGuidedTour();
}

function onSkip() {
	showWelcome.value = false;
	markGuidedTourCompleted(false);
}
</script>
